import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20modern%20minimalist%20abstract%20background%20with%20flowing%20gradients%20in%20warm%20teal%20and%20coral%20tones%2C%20soft%20geometric%20shapes%2C%20clean%20and%20youthful%20atmosphere%2C%20digital%20platform%20background%2C%20no%20text%2C%20smooth%20color%20transitions%2C%20contemporary%20design%20aesthetic&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="小蓝视频背景"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-2-line text-accent-400 text-sm"></i>
            <span className="text-background-50/90 text-sm">5000万+用户的选择</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 mb-5 leading-tight font-heading">
            轻量高清，发现你的
            <span className="text-accent-400">精彩世界</span>
          </h1>
          <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            小蓝视频汇聚海量优质短视频内容，智能推荐让你越刷越上瘾。
            支持一键下载离线观看，无论你在哪里，精彩内容永不掉线。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#download"
              className="px-8 py-3.5 bg-primary-500 text-background-50 text-base font-semibold rounded-full whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all duration-300 hover:scale-105"
            >
              <i className="ri-download-cloud-2-line mr-2"></i>
              立即下载
            </a>
            <Link
              to="/category/gaoxiao"
              className="px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/30 text-background-50 text-base font-medium rounded-full whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-all duration-300"
            >
              <i className="ri-play-circle-line mr-2"></i>
              在线观看
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}